/* eslint-disable import/no-anonymous-default-export */
import styles from "./VerifyCode.module.css"
import {  useState} from 'react'
import { useFormik } from 'formik'
import axios from 'axios';
import {  useNavigate } from 'react-router-dom';
    export default function VerifyCode() {
        let [isLoading, setIsLoading] = useState(false);
        const [message,setMesaage] = useState("")
        const [messageError,setMessageError] = useState("");
        let navigate = useNavigate();
        function resetCode(values) {
            setIsLoading(true);
            axios.post(`https://ecommerce.routemisr.com/api/v1/auth/verifyResetCode`, values)
            .then(({ data }) => {
                console.log(data);
                if(data.status === "Success"){
                    setMesaage(data.status);
                    setTimeout(() => {
                        navigate("/resetPassword")
                    },1000)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error.response?.data);
                setMessageError(`${error.response?.data?.statusMsg}: ${error.response?.data?.message}`);
            });
        }
    let formik = useFormik({
        initialValues:{
        "resetCode":""
        },
        onSubmit:resetCode
    })
    return (
        <>
        <div className="w-75 mt-5" style={{marginTop:"300px"}}>
            <h3>Verify Code</h3>
            {messageError.length > 0 ? <div className="alert alert-danger">{messageError}</div> : null}
            {message.length > 0 ? <div className="alert alert-success">{message}</div> : null}
            <form onSubmit={formik.handleSubmit} >

            <label htmlFor="resetCode">Reset Code:</label>
            <input onBlur={formik.handleBlur} className='form-control mb-2' onChange={formik.handleChange} value={formik.values.email} type="text" name="resetCode" id="resetCode" />
            {formik.errors.resetCode && formik.touched.resetCode ?<div className="alert alert-danger">{formik.errors.resetCode}</div> : null}

            {isLoading? <button type='button' className='btn bg-success  text-white'><i className='fas fa-spinner fa-spin'></i></button> : <button disabled={!(formik.isValid && formik.dirty)} type='submit' className='btn bg-success  text-white'>Send</button>}
            </form>
        </div>
        </>
    )
    }
